export enum ReportParameterName {
  RunDate = '@run_date',
  PriorDate = '@prior_date',
  CompanyId = '@company_id',
}
